import businessClient from 'src/services/clients/business'
import { IMeta, IStore } from 'src/common/interfaces/index.js'

const IUpsertResponse = { meta: IMeta, data: { upsert_main: IStore, upsert_business: IStore } }
const IListResponse = { meta: IMeta, data: { list: [IStore] } }

export const branch = {
  /**
   * @param {{store_id: number, row_number: number, page: number}} [filter={}]
   * @return {Promise<IListResponse>}
   */
  list(filter = {}, signal) {
    return businessClient().post('store/portal/list', { filter }, { signal })
  },

  /**
   * @param {IStore} data
   * @return {Promise<IUpsertResponse>}
   */
  upsert(data, signal) {
    return businessClient().post('store/upsert', { data }, { signal })
  },
}
